// check if provided value is a redux action (object with 'type' param)
export const shouldDispatch = (action = {}) => typeof action === 'object' && 'type' in action;
